<template>
  <div class="xv_view" id="Citizens_view_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">{{ this.name }}</label>
      </div>
      <div class="xv_actions">
        <span>Status :</span>
        <span class="main_status_1">Ok</span>
        <!-- <span class="main_status_2">Block</span>
        <span class="main_status_3">Work from home</span>-->
      </div>
    </div>
    <div class="xv_tabs">
      <div>
        <b-tabs content-class="mt-3">
          <!-- ***************** TAB 1 *************************** -->
          <b-tab title="Profile" active>
            <div class="tab_profile">
              <div class="row">
                <div class="col-7">
                  <div class="pro_section">
                    <label>Citizen Id</label>
                    <input type="text" value="Joseph Davis" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Email Id</label>
                    <input
                      type="text"
                      value="josephdavis@gmail.com"
                      :disabled="profile_edit == false"
                    />
                  </div>
                  <div class="pro_section">
                    <label>Mobile number</label>
                    <input type="text" value="+1-202-555-0135" :disabled="profile_edit == false" />
                  </div>

                  <div class="pro_section">
                    <label>Office</label>
                    <select name id :disabled="profile_edit == false">
                      <option value="1">Microsoft</option>
                      <option value="1" selected>Apple</option>
                      <option value="1">Nestle</option>
                      <option value="1">Alphabet</option>
                      <option value="1">Facebook</option>
                      <option value="1">Alibaba</option>
                      <option value="1">Tencent</option>
                    </select>
                  </div>
                  <div class="pro_section">
                    <label>Address</label>

                    <select name id :disabled="profile_edit == false">
                      <option value="1">Super admin</option>
                      <option value="1">Office admin</option>
                      <option value="1">Bio security</option>
                      <option value="1">Employee</option>
                    </select>
                  </div>
                  <div class="pro_section">
                    <label>City</label>
                    <input type="text" value="New York" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>District</label>
                    <input type="text" value="Delaware" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>State</label>
                    <input type="text" value="California" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Pin code</label>
                    <input type="text" value="9294" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Joined On</label>
                    <input type="text" value="5th March,2020 10.00 AM PST" disabled />
                  </div>
                  <div class="pro_section">
                    <label>Last Logged In</label>
                    <input type="text" value="7th March,2020 10.00 AM PST" disabled />
                  </div>

                  <div class="row pro_section">
                    <div class="col-4">
                      <label>Status</label>
                      <select name id :disabled="profile_edit == false">
                        <option value="1">Ok</option>
                        <option value="2">Block</option>
                        <option value="2">Work from home</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <label>Comments</label>
                      <input type="text" :disabled="profile_edit == false" />
                    </div>
                  </div>
                </div>

                <div class="col-5 text-right">
                  <div v-if="profile_edit == false">
                    <button class="pro_btn m_r sec_btn" @click="profile_edit = true">
                      <span class="mdi mdi-pencil"></span>
                    </button>
                    <button class="pro_btn sec_btn" @click="delete_popup()">
                      <span class="mdi mdi-trash-can"></span>
                    </button>
                  </div>

                  <div v-if="profile_edit == true">
                    <button class="pro_btn m_r save save_btn" @click="profile_edit = false">Save</button>
                    <button class="pro_btn cancel delete_btn" @click="profile_edit = false">Cancel</button>
                  </div>

                  <div class="profile_preview">
                    <div class="pro_pic">
                      <img src="../../../../assets/users/1.jpg" alt />
                    </div>
                    <div class="meta_info">
                      <span>Other options are Not Onboarded</span>
                    </div>
                    <div class="pro_infos">
                      <div class="pro_info score">
                        <div class="value">
                          <span>98</span>
                        </div>
                        <div class="title">
                          <span>Health score</span>
                        </div>
                      </div>
                      <div class="pro_info status">
                        <div class="value">
                          <span>Ok</span>
                        </div>
                        <div class="title">
                          <span>Today Health Status</span>
                        </div>
                      </div>
                      <div class="pro_info status">
                        <div class="value">
                          <span>Ok</span>
                        </div>
                        <div class="title">
                          <span>Long Term Health Status</span>
                        </div>
                      </div>
                      <div class="pro_info declaration">
                        <div class="value" @click="view_declaration()">
                          <span>
                            <span class="mdi mdi-clipboard-text-outline"></span>9th March,2020
                          </span>
                        </div>
                        <div class="title">
                          <span>Declaration</span>
                        </div>
                      </div>
                      <div class="pro_info alert">
                        <div class="value">
                          <span>2</span>
                        </div>
                        <div class="title">
                          <span>Critical Alert</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <!-- ***************** TAB 2 *************************** -->
          <b-tab title="Alerts">
            <div class="xv_table">
              <div class="xv_table_title">
                <div>
                  <span>Alerts(5) this week</span>
                </div>
                <div>
                  <button class="sec_btn" @click="table_filter_a()">
                    Filter
                    <span class="mdi mdi-filter-menu"></span>
                  </button>
                </div>
              </div>

              <div class="filter_wrap">
                <div class="left_filter" v-if="left_filter_a == true">
                  <div class="header_section top">
                    <div>
                      <span class="main_title">
                        Filter
                        <span class="mdi mdi-filter-menu"></span>
                      </span>
                    </div>
                    <div>
                      <span class="option">Reset</span>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Date</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="range"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Locations</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <multiselect
                        v-model="multiselect"
                        :options="[
                          'Borad room',
                          'Meeting room',
                          'Food court',
                          'Parking'
                        ]"
                        :multiple="true"
                      ></multiselect>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Type</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">High Temperature</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Low XV Score</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Quarantine Contact</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-8" name="checkbox-8"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Traveled to Korea</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="alerts_table">
                  <thead>
                    <tr>
                      <th style>Date/Time</th>
                      <th style="text-align:center">Status</th>
                      <th style="text-align:center">Alert</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>

                      <td class="status_1">
                        <span>Ok</span>
                      </td>
                      <td>Quarantine Violation</td>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>

                      <td class="status_2">
                        <span>Block</span>
                      </td>
                      <td>Health Status Not Updated</td>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>

                      <td class="status_1">
                        <span>Ok</span>
                      </td>
                      <td>Health Status Not Updated</td>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>

                      <td class="status_1">
                        <span>Ok</span>
                      </td>
                      <td>Quarantine Violation</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <!-- ***************** TAB 3 *************************** -->
          <b-tab title="Health Declaration">
            <div class="xv_table">
              <div class="xv_table_title">
                <div>
                  <span>Declarations (5) for this week</span>
                </div>
                <div>
                  <button class="sec_btn" @click="table_filter_hd()">
                    Filter
                    <span class="mdi mdi-filter-menu"></span>
                  </button>
                </div>
              </div>

              <div class="filter_wrap">
                <div class="left_filter" v-if="left_filter_hd == true">
                  <div class="header_section top">
                    <div>
                      <span class="main_title">
                        Filter
                        <span class="mdi mdi-filter-menu"></span>
                      </span>
                    </div>
                    <div>
                      <span class="option">Reset</span>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Date</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="range"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Health</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                        </div>
                        <div class="check_label">
                          <span>Ok</span>
                        </div>
                      </div>

                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-3" name="checkbox-3"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Diagnosed</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-4" name="checkbox-4"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Suspect</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Travel History</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Ok</span>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Violation</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Quaratine</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Ok</span>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Quaratine</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="e_health_table">
                  <thead>
                    <tr>
                      <th style>Date</th>
                      <th style="text-align:center">Health</th>
                      <th style="text-align:center">Travel History</th>
                      <th style="text-align:center">Quaratine</th>
                      <th style="text-align:center">View</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Ok</span>
                      </td>
                      <td>
                        <span>Ok</span>
                      </td>
                      <td>
                        <span>Ok</span>
                      </td>
                      <td>
                        <span class="mdi mdi-clipboard-text-outline" @click="view_declaration"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <!-- ***************** TAB 4 *************************** -->
          <b-tab title="Case management">
            <div class="case_tracing">
              <div class="xv_top">
                <div></div>
                <div class="xv_actions">
                  <button class="main_btn" @click="add_update()">
                    Add update
                    <span class="mdi mdi-plus-thick"></span>
                  </button>
                </div>
              </div>
              <div class="trace">
                <div class="section diagnostics">
                  <label class="sec_title">Diagnostics</label>
                  <div class="content">
                    <div class="data_row">
                      <div class="data_col">
                        <div class="title">
                          <span>Date</span>
                        </div>
                        <div class="value">
                          <span>04-Jan-2020</span>
                        </div>
                      </div>

                      <div class="data_col">
                        <div class="title">
                          <span>Sample Id</span>
                        </div>
                        <div class="value">
                          <span>#345634</span>
                        </div>
                      </div>

                      <div class="data_col">
                        <div class="title">
                          <span>Status</span>
                        </div>
                        <div class="value">
                          <span>Ok</span>
                        </div>
                      </div>
                    </div>
                    <div class="second_row">
                      <div class="data_col">
                        <div class="title">
                          <span>Comments</span>
                        </div>
                        <div class="value">
                          <span>Morbi rhoncus bibendum elementum. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nam id accumsan lacus, gravida lacinia tortor.</span>
                        </div>
                      </div>

                      <div class="data_col multi">
                        <div class="line_1">
                          <div class="left">
                            <div class="title">
                              <span>Assigned to</span>
                            </div>
                            <div class="value">
                              <span>Franklin Clinton</span>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">
                              <span>Date</span>
                            </div>
                            <div class="value">
                              <span>02-Jan-2020</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="option">
                    <button @click=" d1_h == true ? d1_h = false : d1_h = true ">Health status</button>
                  </div>
                  <div class="health_status" v-if="d1_h == true">
                    <div class="data">
                      <div class="left">
                        <label>Temperature</label>
                        <div>
                          <input type="text" value="36 °C" />
                        </div>
                      </div>
                      <div class="right">
                        <label>Symptoms</label>
                        <div class="check_wrap">
                          <b-form-checkbox id="checkbox-1" name="checkbox-1" value="fever">Fever</b-form-checkbox>
                          <b-form-checkbox
                            id="checkbox-2"
                            name="checkbox-2"
                            value="Sore throat"
                            v-model="symtom_1"
                          >Sore throat</b-form-checkbox>
                          <b-form-checkbox
                            id="checkbox-3"
                            name="checkbox-3"
                            value="accepted"
                          >Headache</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section international_arrival">
                  <label class="sec_title">International arrival</label>
                  <div class="content">
                    <div class="data_row">
                      <div class="data_col">
                        <div class="title">
                          <span>Date</span>
                        </div>
                        <div class="value">
                          <span>02-Jan-2020</span>
                        </div>
                      </div>

                      <div class="data_col">
                        <div class="title">
                          <span>Fligt no</span>
                        </div>
                        <div class="value">
                          <span>fvt6543e</span>
                        </div>
                      </div>

                      <div class="data_col">
                        <div class="title">
                          <span>Arrived from</span>
                        </div>
                        <div class="value">
                          <span>Spain</span>
                        </div>
                      </div>

                      <div class="data_col">
                        <div class="title">
                          <span>Travelling to</span>
                        </div>
                        <div class="value">
                          <span>Italy</span>
                        </div>
                      </div>
                    </div>
                    <div class="second_row">
                      <div class="data_col">
                        <div class="title">
                          <span>Comments</span>
                        </div>
                        <div class="value">
                          <span>Morbi rhoncus bibendum elementum. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nam id accumsan lacus, gravida lacinia tortor.</span>
                        </div>
                      </div>

                      <div class="data_col multi">
                        <div class="line_1">
                          <div class="left">
                            <div class="title">
                              <span>Assigned to</span>
                            </div>
                            <div class="value">
                              <span>Franklin Clinton</span>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">
                              <span>Date</span>
                            </div>
                            <div class="value">
                              <span>02-Jan-2020</span>
                            </div>
                          </div>
                        </div>
                        <div class="line_2">
                          <div class="left">
                            <div class="title">
                              <span>Updated by</span>
                            </div>
                            <div class="value">
                              <span>Yasmine Hoffman</span>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">
                              <span>Date</span>
                            </div>
                            <div class="value">
                              <span>02-Jan-2020</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="option">
                    <button @click=" i1_h == true ? i1_h = false : i1_h = true ">Health status</button>
                  </div>
                  <div class="health_status" v-if="i1_h == true">
                    <div class="data">
                      <div class="left">
                        <label>Temperature</label>
                        <div>
                          <input type="text" value="37.5 °C" />
                        </div>
                      </div>
                      <div class="right">
                        <label>Symptoms</label>
                        <div class="check_wrap">
                          <b-form-checkbox
                            id="checkbox-4"
                            name="checkbox-4"
                            value="fever"
                            v-model="symtom_2"
                          >Fever</b-form-checkbox>
                          <b-form-checkbox
                            id="checkbox-5"
                            name="checkbox-5"
                            value="Sore throat"
                          >Sore throat</b-form-checkbox>
                          <b-form-checkbox
                            id="checkbox-6"
                            name="checkbox-6"
                            value="accepted"
                          >Headache</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <!-- ***************** TAB 5 *************************** -->
          <b-tab title="Contact tracing">
            <div class="xv_top">
              <div></div>
              <div class="xv_actions">
                <button class="sec_btn" @click="table_filter_trace()">
                  Filter
                  <span class="mdi mdi-filter-menu"></span>
                </button>
              </div>
            </div>
            <div class="filter_wrap filter_trace">
              <!-- Filter -->
              <div class="left_filter" v-if="left_filter_trace == true">
                <div class="header_section top">
                  <div>
                    <span class="main_title">
                      Filter
                      <span class="mdi mdi-filter-menu"></span>
                    </span>
                  </div>
                  <div>
                    <span class="option">Reset</span>
                  </div>
                </div>
                <div class="section">
                  <div class="header_section">
                    <div>
                      <span class="title">Trace</span>
                    </div>
                    <div>
                      <span class="option">Clear</span>
                    </div>
                  </div>

                  <div class="content">
                    <div class="xv_datepicker">
                      <span class="mdi mdi-calendar-month"></span>
                      <vc-date-picker
                        mode="range"
                        :popover="{ visibility: 'click' }"
                        :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                        :masks="{ input: 'DD/MM/YY' }"
                      />
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="header_section">
                    <div>
                      <span class="title">App</span>
                    </div>
                    <div>
                      <span class="option">Clear</span>
                    </div>
                  </div>

                  <div class="content">
                    <div class="xv_datepicker">
                      <span class="mdi mdi-calendar-month"></span>
                      <vc-date-picker
                        mode="range"
                        :popover="{ visibility: 'click' }"
                        :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                        :masks="{ input: 'DD/MM/YY' }"
                      />
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="header_section">
                    <div>
                      <span class="title">Cell</span>
                    </div>
                    <div>
                      <span class="option">Clear</span>
                    </div>
                  </div>

                  <div class="content">
                    <div class="xv_datepicker">
                      <span class="mdi mdi-calendar-month"></span>
                      <vc-date-picker
                        mode="range"
                        :popover="{ visibility: 'click' }"
                        :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                        :masks="{ input: 'DD/MM/YY' }"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- Table -->
              <div class="xv_table">
                <div class="xv_table_title">
                  <div>
                    <span>Traces</span>
                  </div>
                  <div>
                    <button class="main_btn" @click="new_row = true">
                      Add
                      <span class="mdi mdi-plus-thick"></span>
                    </button>
                  </div>
                </div>

                <div class="filter_wrap">
                  <table class="case_tracing_table">
                    <thead>
                      <tr>
                        <th style>Date</th>
                        <th style="text-align:center">Location</th>
                        <th style="text-align:center">Person met</th>
                        <th style="text-align:center">Type</th>
                        <th style="text-align:center">Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span>02-Jan-2020 10:30am</span>
                        </td>
                        <td>
                          <span>Airport,chennai</span>
                        </td>
                        <td>
                          <span>Saira Mays</span>
                        </td>
                        <td>
                          <span>Gathering</span>
                        </td>
                        <td>
                          <span>24 mins</span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <span>01-Jan-2020 11:30am</span>
                        </td>
                        <td>
                          <span>Marina beach,chennai</span>
                        </td>
                        <td>
                          <span>SJules Case,Kaleb Read</span>
                        </td>
                        <td>
                          <span>Gathering</span>
                        </td>
                        <td>
                          <span>56 mins</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>01-Jan-2020 09:00pm</span>
                        </td>
                        <td>
                          <span>Kfc restaurant,chennai</span>
                        </td>
                        <td>
                          <span>Saira Mays</span>
                        </td>
                        <td>
                          <span>Gathering</span>
                        </td>
                        <td>
                          <span>30 mins</span>
                        </td>
                      </tr>
                      <tr v-for="row in new_row_data" :key="row.id">
                        <td>{{ row.data_1 }}</td>
                        <td>{{ row.data_2 }}</td>
                        <td>{{ row.data_3 }}</td>
                        <td>{{ row.data_4 }}</td>
                        <td>{{ row.data_5 }}</td>
                      </tr>
                      <tr v-if="new_row == true">
                        <td>
                          <div class="xv_datepicker">
                            <span class="mdi mdi-calendar-month"></span>
                            <vc-date-picker
                              mode="single"
                              v-model="data_1"
                              :popover="{ visibility: 'click' }"
                              :input-props="{
                    class: 'picker_input',
                    placeholder: '',
                    readonly: true
                  }"
                              :masks="{ input: 'DD-MMM-YY',data: 'DD-MMM-YY' }"
                            />
                          </div>
                        </td>
                        <td>
                          <input type="text" v-model="data_2" />
                        </td>
                        <td>
                          <input type="text" v-model="data_3" />
                        </td>
                        <td>
                          <input type="text" v-model="data_4" />
                        </td>
                        <td>
                          <input type="text" v-model="data_5" />
                        </td>
                      </tr>
                      <tr v-if="new_row == true">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colspan="2" class="text-right">
                          <button class="save" @click="save_new_row()">Save</button>
                          <button class="cancel" @click="cancel_new_row()">Cancel</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- App/Cell -->
              <div class="trace_tabs">
                <div class="tabs">
                  <button @click="trace_tab = 'app'" :class="{active: trace_tab == 'app'}">App</button>
                  <button @click="trace_tab = 'cell'" :class="{active: trace_tab == 'cell'}">Cell</button>
                </div>
                <div class="tab_data">
                  <div class="app" v-if="trace_tab == 'app'">
                    <ul class="timeline">
                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">02 Jan</div>
                          <div class="time">12:30pm</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Airport, Chennai, Tamil nadu</label>
                          <span class="sec_text">
                            <div>5814823748, 10m, 20mins</div>
                          </span>
                        </div>
                      </li>

                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">01 Jan</div>
                          <div class="time">12:30pm</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Government Museum, Chennai, Tamil naduu</label>
                          <span class="sec_text">
                            <div>5814823748, 10m, 20mins</div>
                            <div>5814823748, 10m, 20mins</div>
                          </span>
                        </div>
                      </li>

                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">26 Feb</div>
                          <div class="time">12:30pm</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Kfc restaurant, Chennai, Tamil nadu</label>
                          <span class="sec_text">
                            <div>5814823748, 10m, 20mins</div>
                            <div>8767565466, 07m, 28mins</div>
                          </span>
                        </div>
                      </li>

                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">25 Feb</div>
                          <div class="time">11:30pm</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Marina beach, Chennai, Tamil nadu</label>
                          <span class="sec_text">
                            <div>5814823748, 10m, 20mins</div>
                            <div>8767565466, 07m, 28mins</div>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="cell" v-if="trace_tab == 'cell'">
                    <ul class="timeline">
                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">04 Jan</div>
                          <div class="time">11:00am</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Airport, Chennai, Tamil nadu</label>
                        </div>
                      </li>

                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">03 Jan</div>
                          <div class="time">01:30pm</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Marina beach, Chennai, Tamil nadu</label>
                        </div>
                      </li>

                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">02 Jan</div>
                          <div class="time">04:30pm</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Kfc restaurant, Chennai, Tamil nadu</label>
                        </div>
                      </li>

                      <li class="timeline_sec">
                        <span class="timeline_info">
                          <div class="date">01 Jan</div>
                          <div class="time">12:30pm</div>
                        </span>
                        <div class="timeline_content">
                          <label class="sec_heading">Government Museum, Chennai, Tamil nadu</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <!-- Add update -->
    <modal name="add_update" transition="pop-out" :width="1000" height="auto">
      <addUpdate></addUpdate>
    </modal>
    <!-- Delete popup -->
    <modal name="delete_popup" transition="pop-out" :width="450" height="auto">
      <deletePopup delete_text="Do you really want to delete this employee? This cannot be undone."></deletePopup>
    </modal>
    <!-- Declaration preview -->
    <modal
      name="declaration_preview"
      transition="pop-out"
      :width="720"
      height="auto"
      :scrollable="true"
    >
      <declarationPreview></declarationPreview>
    </modal>
  </div>
</template>

<script>
import deletePopup from "../../../layout/delete_popup/delete_popup.vue";
import declarationPreview from "../../../views/health_declaration/declaration_preview/declaration_preview.vue";
import addUpdate from "../add_update/add_update.vue";
export default {
  name: "Citizens_view_G",
  components: {
    addUpdate,
    deletePopup,
    declarationPreview
  },
  data() {
    return {
      name: "",
      left_filter: false,
      left_filter_hd: false,
      left_filter_a: false,
      profile_edit: false,
      left_filter_trace: false,
      multiselect: null,
      d1_h: false,
      i1_h: false,
      trace_tab: "app",
      new_row: false,
      new_row_data: [],
      data_1: "",
      data_2: "",
      data_3: "",
      data_4: "",
      data_5: "",
      symtom_1: "Sore throat",
      symtom_2: "fever"
    };
  },
  // watch: {
  //   "$route.params.id": function() {
  //     this.name = this.$route.params.id.slice(1);
  //   }
  // },
  created() {
    this.name = this.$route.params.id.slice(1);
  },
  methods: {
    delete_popup: function() {
      this.$modal.show("delete_popup");
    },
    add_update: function() {
      this.$modal.show("add_update");
    },
    table_filter: function() {
      if (this.left_filter == false) {
        this.left_filter = true;
      } else {
        this.left_filter = false;
      }
    },
    table_filter_hd: function() {
      if (this.left_filter_hd == false) {
        this.left_filter_hd = true;
      } else {
        this.left_filter_hd = false;
      }
    },
    table_filter_a: function() {
      if (this.left_filter_a == false) {
        this.left_filter_a = true;
      } else {
        this.left_filter_a = false;
      }
    },
    table_filter_trace: function() {
      if (this.left_filter_trace == false) {
        this.left_filter_trace = true;
      } else {
        this.left_filter_trace = false;
      }
    },
    view_declaration: function() {
      this.$modal.show("declaration_preview");
    },
    save_new_row: function() {
      this.new_row = false;

      var data = {
        data_1: "02-Jan-2020 10:30am",
        data_2: this.data_2,
        data_3: this.data_3,
        data_4: this.data_4,
        data_5: this.data_5
      };
      this.new_row_data.push(data);

      this.data_1 = "";
      this.data_2 = "";
      this.data_3 = "";
      this.data_4 = "";
      this.data_5 = "";
    },
    cancel_new_row: function() {
      this.new_row = false;
    }
  }
};
</script>
